import { isEmpty } from 'ramda';

export default {
  adminsPath: () => '/admins',
  billingSettingsPath: () => '/billing-settings',
  brandsPath: () => '/brands',
  cashbackPath: (cashbackId) => `/cashbacks/${cashbackId}`,
  cashbackEditPath: (cashbackId) => `/cashbacks/${cashbackId}/edit`,
  cashbacksDashboardPath: () => '/cashbacks',
  categoriesPath: () => '/categories',
  flashOffersPath: () => '/flash-offers',
  happeningsPath: () => '/happenings/tab/active',
  newCashbackPath: (fastCashId) => `/fastcashes/${fastCashId}/cashbacks/new`,
  mallInfoPath: () => '/mall-info',
  membershipSettingsPath: () => '/membership-settings',
  messagesPath: () => '/messages/tab/active',
  offersPath: () => '/offers/tab/active',
  qrCodesPath: () => '/qr-codes',
  supportPath: () => '/support',
  supportRequestPath: (supportRequestId) => `/support/${supportRequestId}`,
  topOffersPath: () => '/top-offers',
  transactionPath: (transactionId) => `/transactions/${transactionId}`,
  transactionsDashboardPath: (params = {}) => {
    if (isEmpty(params)) return '/transactions';
    const queryString = formQueryString(params);
    const path = `/transactions?${queryString}`;

    return path;
  },
  transactionsPath: () => '/fastcash#transactions',
  usersPath: () => '/fastcash/users',
  userFastCashPath: (params = {}) => {
    const queryString = formQueryString(params);
    const path = `/fastcash?${queryString}#transactions`;

    return path;
  },
  membershipsPath: (fastCashId) => `/fastcash/${fastCashId}/memberships`,
  bannerSettingsPath: () => `/banner-settings`,
  storesPath: () => `/brands`,
  storeShowPath: (storeId) => `/brands/${storeId}`,
  cashbackRatesPath: (storeId) => `/brands/${storeId}/cashback-rates`,
  invoicesPath: (storeId) => `/brands/${storeId}/invoices`,
  quicksightPath: () => '/quicksight',
  newBonusPath: (userId) => `/bonuses/${userId}/bonuses/new`,
  multiBonusPath: () => '/multibonus',
};

const formQueryString = (params) => {
  const queryParams = Object.entries(params).map(([k, v]) => `${k}=${v}`);
  const queryString = queryParams.join('&');

  return queryString;
};
